export interface Score {
  id: string;
  playerName: string;
  email: string;
  phone?: string;
  interest?: string;
  company?: string;
  moves: number;
  timestamp: string;
}

const API_URL = 'https://yl2vni1bpc.execute-api.eu-north-1.amazonaws.com/scores';

export const saveScore = async (score: Score): Promise<Score> => {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: score.id,
      playerName: score.playerName,
      email: score.email,
      phone: score.phone,
      interest: score.interest,
      company: score.company,
      moves: score.moves,
      timestamp: score.timestamp,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to save score');
  }

  const data = await response.json();
  return data.item;
};

export const getScores = async (): Promise<Score[]> => {
  const response = await fetch(API_URL);

  if (!response.ok) {
    throw new Error('Failed to fetch scores');
  }

  const data = await response.json();
  return data;
}; 